export enum MorseRadioGroupExpressions {
  HELP_DEAMBULAR = 'helpDeambular',
  MENTAL_STATE = 'mentalState',
  WALKING_MODE = 'walkingMode'
}

export enum MorseRadioGroupId {
  HELP_DEAMBULAR = 614296,
  MENTAL_STATE = 614298,
  WALKING_MODE = 614300
}
